module.exports = __webpack_public_path__ + "img/img-profile.b53543f5.png";